import React from 'react'
import Routes from './routes/Routes'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import { ConnectedRouter } from 'connected-react-router'
import { createHashHistory } from 'history'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'purecss'
import '../src/styles/Main.scss'

const history = createHashHistory()
const store = configureStore(history)

const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Routes />
      <div id="divLoading" className='hide-loader'>Loading...</div>
      <div id="divDownloading" className='hide-loader'>
        <span className='downloading-icon'><img src='../images/Processing.gif' /></span>
        <span className='download-text'>Processing download....</span>
      </div>
      <div id="divDownloaded" className='hide-loader'>
        <span className='download-complete-icon'></span>
        <span className='download-text'>Download Complete</span>
      </div>
    </ConnectedRouter>
  </Provider>
)

export default App
